import { Component, OnInit } from '@angular/core';

import { MenuService } from '../services/menu.service';

@Component({
    selector: 'fw-menu',
    template: require('./menu.component.html'),
    styles: [require('./menu.component.css')]
})
export class MenuComponent implements OnInit {

    constructor(private menuService: MenuService) { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/menu/menu.component.ts